import React from "react";

export default function PrivacyPolicy() {
  const styles = {
    wrap: { maxWidth: 900, margin: "0 auto", padding: "32px 20px", lineHeight: 1.6, color: "#0b1220" },
    h1: { fontSize: 32, marginBottom: 8 },
    small: { color: "#6b7280", fontSize: 14, marginBottom: 24, display: "block" },
    h2: { fontSize: 22, marginTop: 28, marginBottom: 8 },
    h3: { fontSize: 18, marginTop: 22, marginBottom: 8 },
    p: { margin: "10px 0" },
    ul: { margin: "10px 0 10px 18px" },
    li: { margin: "6px 0" },
    note: { background: "#f8fafc", border: "1px solid #e5e7eb", padding: 12, borderRadius: 8, fontSize: 14 },
    tableWrap: { overflowX: "auto", marginTop: 8, marginBottom: 8 },
    table: { borderCollapse: "collapse", width: "100%", minWidth: 720 },
    th: { textAlign: "left", borderBottom: "1px solid #e5e7eb", padding: "10px 8px", fontWeight: 600 },
    td: { borderBottom: "1px solid #f1f5f9", padding: "10px 8px", verticalAlign: "top" },
    code: { background: "#f3f4f6", padding: "2px 6px", borderRadius: 4, fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace" },
    hr: { border: 0, borderTop: "1px solid #e5e7eb", margin: "24px 0" },
    nav: { display: "flex", flexWrap: "wrap", gap: 12, margin: "8px 0 16px" },
    navLink: { fontSize: 14, color: "#2563eb", textDecoration: "none" },
  };

  // ⬇⬇⬇ COMPILA QUI I TUOI DATI REALI ⬇⬇⬇
  const SITE = {
    name: "Dottoressa Rosa Coppola",
    vat: "",             // opzionale
    pec: "",            // opzionale
    domain: "www.dottoressarosacoppola.it",
    legalAddress: "Corso Giuseppe Garibaldi, 47, 84123 Salerno SA",
    contactEmail: "info@dottoressarosacoppola.it",
    phone: "+39 348 692 7058",        // opzionale
    dpoName: "",                      // opzionale
    dpoEmail: "",                     // opzionale
    lastUpdate: "24 settembre 2025",
  };

  return (
    <main style={{ ...styles.wrap, marginTop: 150 }} role="main" aria-labelledby="privacy-title">
      <h1 id="privacy-title" style={styles.h1}>Privacy Policy</h1>
      <small style={styles.small}>Ultimo aggiornamento: {SITE.lastUpdate}</small>

      <div style={styles.note}>
        Questa informativa descrive le modalità di trattamento dei dati personali relative al sito <strong>{SITE.domain}</strong> (sito vetrina con sezione blog, rimandi ai social e form di contatto), ai sensi del Regolamento (UE) 2016/679 (“GDPR”) e della normativa nazionale applicabile.
      </div>

      <nav aria-label="Indice della pagina" style={styles.nav}>
        <a href="#titolare" style={styles.navLink}>1. Titolare del trattamento</a>
        <a href="#dati-trattati" style={styles.navLink}>2. Tipologie di dati trattati</a>
        <a href="#finalita-basi" style={styles.navLink}>3. Finalità e basi giuridiche</a>
        <a href="#conferimento" style={styles.navLink}>4. Conferimento dei dati</a>
        <a href="#conservazione" style={styles.navLink}>5. Tempi di conservazione</a>
        <a href="#destinatari" style={styles.navLink}>6. Destinatari e categorie di destinatari</a>
        <a href="#trasferimenti" style={styles.navLink}>7. Trasferimenti extra-UE</a>
        <a href="#diritti" style={styles.navLink}>8. Diritti degli interessati</a>
        <a href="#sicurezza" style={styles.navLink}>9. Misure di sicurezza</a>
        <a href="#minori" style={styles.navLink}>10. Dati dei minori</a>
        <a href="#modifiche" style={styles.navLink}>11. Modifiche all’informativa</a>
        <a href="#contatti" style={styles.navLink}>12. Contatti</a>
      </nav>

      <section id="titolare">
        <h2 style={styles.h2}>1. Titolare del trattamento</h2>
        <p style={styles.p}><strong>{SITE.name}</strong>{SITE.vat ? ` (P.IVA: ${SITE.vat})` : ""}</p>
        <p style={styles.p}><strong>Sede legale:</strong> {SITE.legalAddress}</p>
        {SITE.pec && <p style={styles.p}><strong>PEC:</strong> <a href={`mailto:${SITE.pec}`}>{SITE.pec}</a></p>}
        {SITE.phone && <p style={styles.p}><strong>Telefono:</strong> {SITE.phone}</p>}
        <p style={styles.p}><strong>Email di contatto privacy:</strong> <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a></p>
        {SITE.dpoEmail && (
          <p style={styles.p}>
            <strong>Data Protection Officer (DPO):</strong> {SITE.dpoName ? `${SITE.dpoName} – ` : ""}<a href={`mailto:${SITE.dpoEmail}`}>{SITE.dpoEmail}</a>
          </p>
        )}
      </section>

      <section id="dati-trattati">
        <h2 style={styles.h2}>2. Tipologie di dati trattati</h2>
        <h3 style={styles.h3}>2.1 Dati di navigazione</h3>
        <p style={styles.p}>
          Sistemi informatici e procedure software preposte al funzionamento del sito acquisiscono, nel corso del loro
          esercizio, alcuni dati personali la cui trasmissione è implicita nell’uso dei protocolli di comunicazione di Internet
          (es. indirizzi IP, URI/URL delle risorse richieste, orario della richiesta, dimensione del file, codice numerico
          indicante lo stato della risposta del server, ecc.). Tali dati sono utilizzati al solo fine di ricavare informazioni
          statistiche anonime sull’uso del sito e per controllarne il corretto funzionamento e vengono cancellati
          immediatamente dopo l’elaborazione, salvo eventuali accertamenti di reati informatici.
        </p>

        <h3 style={styles.h3}>2.2 Cookie e tecnologie simili</h3>
        <p style={styles.p}>
          Il sito utilizza cookie tecnici e, previo consenso, cookie di preferenze/analitici/marketing di terze parti
          connessi a contenuti del blog e rimandi social. Per dettagli, si rinvia alla <a href="/cookie-policy">Cookie Policy</a>.
        </p>

        <h3 style={styles.h3}>2.3 Dati forniti volontariamente dall’utente</h3>
        <ul style={styles.ul}>
          <li style={styles.li}><strong>Form di contatto:</strong> nome, cognome, email, telefono (se richiesto), contenuto del messaggio e altri dati da te inseriti.</li>
          <li style={styles.li}><strong>Sezione blog (es. commenti, se attivi):</strong> nome o nickname, email ed eventuali contenuti testuali.</li>
          <li style={styles.li}><strong>Comunicazioni via email/telefono/social:</strong> dati necessari a gestire la tua richiesta.</li>
        </ul>
      </section>

      <section id="finalita-basi">
        <h2 style={styles.h2}>3. Finalità del trattamento e basi giuridiche</h2>
        <div style={styles.tableWrap}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Finalità</th>
                <th style={styles.th}>Base giuridica (art. 6 GDPR)</th>
                <th style={styles.th}>Esempi di dati</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.td}><strong>Funzionamento e sicurezza del sito</strong></td>
                <td style={styles.td}>Legittimo interesse del Titolare (art. 6.1.f)</td>
                <td style={styles.td}>Dati di navigazione, log tecnici, cookie tecnici</td>
              </tr>
              <tr>
                <td style={styles.td}><strong>Gestione richieste inviate tramite form di contatto</strong></td>
                <td style={styles.td}>Esecuzione di misure precontrattuali/contratto (art. 6.1.b)</td>
                <td style={styles.td}>Identificativi, contatti, contenuto messaggi</td>
              </tr>
              <tr>
                <td style={styles.td}><strong>Blog e interazione con contenuti</strong></td>
                <td style={styles.td}>Legittimo interesse/consenso a seconda delle funzionalità (art. 6.1.f / 6.1.a)</td>
                <td style={styles.td}>Nome/alias, email, testo commenti (se attivi)</td>
              </tr>
              <tr>
                <td style={styles.td}><strong>Analisi statistiche (aggregate/anonime ove possibile)</strong></td>
                <td style={styles.td}>Consenso (art. 6.1.a) o legittimo interesse se anonimizzate</td>
                <td style={styles.td}>Eventi di navigazione, pagine viste</td>
              </tr>
              <tr>
                <td style={styles.td}><strong>Marketing e remarketing (se implementati)</strong></td>
                <td style={styles.td}>Consenso (art. 6.1.a)</td>
                <td style={styles.td}>Identificatori online, cookie marketing</td>
              </tr>
              <tr>
                <td style={styles.td}><strong>Adempimenti legali</strong></td>
                <td style={styles.td}>Obbligo legale (art. 6.1.c)</td>
                <td style={styles.td}>Dati necessari a ottemperare a richieste dell’Autorità</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section id="conferimento">
        <h2 style={styles.h2}>4. Conferimento dei dati</h2>
        <p style={styles.p}>
          Il conferimento dei dati indicati come necessari nel form di contatto è indispensabile per evadere la richiesta;
          il mancato conferimento comporta l’impossibilità di fornire riscontro. Per attività basate su consenso (es. cookie
          non tecnici) il conferimento è facoltativo e revocabile in qualsiasi momento.
        </p>
      </section>

      <section id="conservazione">
        <h2 style={styles.h2}>5. Tempi di conservazione</h2>
        <ul style={styles.ul}>
          <li style={styles.li}><strong>Dati di contatto:</strong> tempo strettamente necessario a gestire la richiesta e, se nasce un rapporto contrattuale, per tutta la durata del rapporto e per i termini di legge (fiscali/contabili).</li>
          <li style={styles.li}><strong>Dati di navigazione/log:</strong> di norma pochi giorni/settimane, salvo esigenze di sicurezza o accertamento reati.</li>
          <li style={styles.li}><strong>Cookie:</strong> secondo quanto indicato nella <a href="/cookie-policy">Cookie Policy</a> e/o nel centro preferenze.</li>
          <li style={styles.li}><strong>Contenuti del blog/commenti (se attivi):</strong> fino a richiesta di cancellazione o moderazione.</li>
        </ul>
      </section>

      <section id="destinatari">
        <h2 style={styles.h2}>6. Destinatari e categorie di destinatari</h2>
        <p style={styles.p}>
          I dati possono essere trattati da persone autorizzate dal Titolare e da fornitori che agiscono come Responsabili
          del trattamento (art. 28 GDPR) per servizi di: hosting, manutenzione IT, invio comunicazioni, analytics, antispam/captcha,
          piattaforme di gestione contenuti, social widget/embeds. L’elenco aggiornato dei Responsabili è disponibile su richiesta.
        </p>
      </section>

      <section id="trasferimenti">
        <h2 style={styles.h2}>7. Trasferimenti di dati verso Paesi extra-UE</h2>
        <p style={styles.p}>
          Alcuni fornitori potrebbero avere sedi o server in Paesi extra-UE. In tali casi, il trasferimento avverrà nel
          rispetto degli artt. 44–49 GDPR, ad esempio sulla base di decisioni di adeguatezza della Commissione Europea,
          Clausole Contrattuali Standard (SCC) o altre garanzie adeguate. Maggiori informazioni sono disponibili
          contattando il Titolare.
        </p>
      </section>

      <section id="diritti">
        <h2 style={styles.h2}>8. Diritti degli interessati</h2>
        <p style={styles.p}>
          In qualità di interessato, puoi esercitare i diritti previsti dagli artt. 15–22 GDPR (accesso, rettifica,
          cancellazione, limitazione, portabilità, opposizione, revoca del consenso) scrivendo a{" "}
          <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a>. Hai inoltre diritto di proporre reclamo
          all’Autorità Garante per la protezione dei dati personali competente.
        </p>
      </section>

      <section id="sicurezza">
        <h2 style={styles.h2}>9. Misure di sicurezza</h2>
        <p style={styles.p}>
          Il Titolare adotta misure tecniche e organizzative adeguate per garantire un livello di sicurezza proporzionato
          al rischio (es. cifratura in transito, sistemi di logging, controlli di accesso, hardening e backup).
        </p>
      </section>

      <section id="minori">
        <h2 style={styles.h2}>10. Dati dei minori</h2>
        <p style={styles.p}>
          I servizi del sito sono rivolti al pubblico generale e non raccolgono consapevolmente dati personali di minori di 14/16 anni
          (a seconda della normativa nazionale). Qualora venisse a conoscenza della raccolta involontaria, il Titolare
          provvederà alla cancellazione dei dati nel più breve tempo possibile.
        </p>
      </section>

      <section id="modifiche">
        <h2 style={styles.h2}>11. Modifiche all’informativa</h2>
        <p style={styles.p}>
          Il Titolare può modificare la presente informativa per aggiornamenti normativi o tecnici. Le modifiche saranno
          pubblicate su questa pagina e diventeranno efficaci dalla data di pubblicazione.
        </p>
      </section>

      <section id="contatti">
        <h2 style={styles.h2}>12. Contatti</h2>
        <p style={styles.p}><strong>Titolare:</strong> {SITE.name}</p>
        <p style={styles.p}><strong>Sede legale:</strong> {SITE.legalAddress}</p>
        {SITE.vat && <p style={styles.p}><strong>P.IVA:</strong> {SITE.vat}</p>}
        <p style={styles.p}><strong>Email privacy:</strong> <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a></p>
        {SITE.phone && <p style={styles.p}><strong>Telefono:</strong> {SITE.phone}</p>}
        {SITE.pec && <p style={styles.p}><strong>PEC:</strong> <a href={`mailto:${SITE.pec}`}>{SITE.pec}</a></p>}
        {SITE.dpoEmail && (
          <p style={styles.p}>
            <strong>DPO:</strong> {SITE.dpoName ? `${SITE.dpoName} – ` : ""}<a href={`mailto:${SITE.dpoEmail}`}>{SITE.dpoEmail}</a>
          </p>
        )}
        <hr style={styles.hr} />
        <p style={{ ...styles.p, ...styles.note }}>
          Per le informazioni sui cookie e per gestire/revocare i consensi, visita la nostra <a href="/cookie-policy">Cookie Policy</a>.
        </p>
      </section>
    </main>
  );
}
